<script setup>
import { ref, onMounted, computed } from 'vue'
import DoneProductItemForSaleTable from '@/components/DoneProducts/DoneProductItemForSaleTable.vue'
import PaginatorComponent from '@/components/PaginatorComponent.vue'
import CardBoxComponentEmpty from '@/components/CardBoxComponentEmpty.vue'
import CardBox from '@/components/CardBox.vue'
import BaseButtons from '@/components/BaseButtons.vue'
import BaseButton from '@/components/BaseButton.vue'

import { useDoneProductsStore } from '@/stores/doneproducts'

import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const doneProductStore = useDoneProductsStore()
const itemsPaginated = ref([])
const period = ref('today')

onMounted(async() => {
  let query = new URLSearchParams({
    only_positive_amount: true,
    period: "today",
  })
  await doneProductStore.fetchDoneProductsForSales(query)
})

const items = computed(() => doneProductStore.doneProductsForSales)
async function handleClickPeriodBtn(clickedPeriod) {
  period.value = clickedPeriod
    let query = new URLSearchParams({
    only_positive_amount: true,
    period: clickedPeriod,
  })
  await doneProductStore.fetchDoneProductsForSales(query)
}
</script>

<template>
      <BaseButtons type="justify-center" mb="mb-1">
        <BaseButton
          :label="t('dashboard.salesToday')"
          :color='period == "today"?"black":"contrast"'
          rounded-full
          small
          @click='handleClickPeriodBtn("today")'
        />
        <BaseButton
          :label="t('dashboard.salesWeek')"
          :color='period == "week"?"black":"contrast"'
          rounded-full
          small
          @click='handleClickPeriodBtn("week")'
        />
        <BaseButton
          :label="t('dashboard.salesMonth')"
          :color='period == "month"?"black":"contrast"'
          rounded-full
          small
          @click='handleClickPeriodBtn("month")'
        />
      </BaseButtons>
  <CardBox class="mb-6" has-table>
    <table v-if="items.length">
      <thead>
        <tr>
          <th>{{ t('doneProducts.name') }}</th>
          <th class="w-1/5">{{ t('doneProducts.amount') }}</th>
        </tr>
      </thead>
      <tbody>
        <DoneProductItemForSaleTable
          v-for="doneProduct in itemsPaginated"
          :key="doneProduct.id"
          :done-product="doneProduct"
        />
      </tbody>
    </table>
    <paginator-component v-if="items.length" v-model="itemsPaginated" :items="items"/>
    <CardBoxComponentEmpty v-else />
  </CardBox>
</template>
